import { render, staticRenderFns } from "./RadarList.vue?vue&type=template&id=3c296ed9"
import script from "./RadarList.vue?vue&type=script&lang=js"
export * from "./RadarList.vue?vue&type=script&lang=js"
import style0 from "./RadarList.vue?vue&type=style&index=0&id=3c296ed9&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Opportunity: require('/usr/src/app/components/blocks/Opportunity.vue').default})
